import React from 'react';

// Custom minimalist vector map: Canada + United States with subtle international
// sourcing connection lines. No exact routes, no unsupported office locations.
export const MarketsMap = ({ className = '' }) => (
  <svg
    viewBox="0 0 800 420"
    className={className}
    role="img"
    aria-label="Map highlighting Canada and the United States with subtle international sourcing connections"
  >
    <defs>
      <linearGradient id="na-fill" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#1A2D58" />
        <stop offset="1" stopColor="#091D47" />
      </linearGradient>
    </defs>
    {/* Simplified North America landmass */}
    <path
      d="M120 90 C160 70 240 66 300 78 C330 84 360 78 392 88 L404 128 L372 150 L360 196 L332 214 L318 250 L286 262 L262 300 L232 300 L214 268 L182 258 L160 224 L150 186 L120 160 Z"
      fill="url(#na-fill)"
      stroke="#D0A350"
      strokeOpacity="0.5"
      strokeWidth="1.5"
    />
    {/* Canada / US divider hairline */}
    <path d="M150 158 L372 150" stroke="#D0A350" strokeOpacity="0.55" strokeWidth="1" strokeDasharray="4 5" />
    {/* Sourcing connection nodes (abstract international regions) */}
    {[
      [560, 150],
      [640, 220],
      [600, 300],
      [700, 120],
    ].map(([x, y], i) => (
      <g key={i}>
        <line x1={300} y1={170} x2={x} y2={y} stroke="#D0A350" strokeOpacity="0.35" strokeWidth="1" strokeDasharray="3 6" />
        <circle cx={x} cy={y} r={5} fill="#D0A350" />
        <circle cx={x} cy={y} r={10} fill="none" stroke="#D0A350" strokeOpacity="0.35" />
      </g>
    ))}
    {/* North America anchor node */}
    <circle cx={300} cy={170} r={7} fill="#FBF9F4" stroke="#D0A350" strokeWidth="2" />
  </svg>
);
